import * as requestsManagerActionCreators from '../../../../redux/modules/requests-manager';

const mapStateToProps = state => ({
  selectedRequests: state.requestsForManager.selectedRequests,
});

const mapDispatchToProps = {
  ...requestsManagerActionCreators
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/admin/table/row/index.js